// Simple seeded PRNG (Mulberry32)
export class SeededRandom {
  private state: number;

  constructor(seed: number) {
    this.state = seed;
  }

  next(): number {
    this.state |= 0;
    this.state = (this.state + 0x6d2b79f5) | 0;
    let t = Math.imul(this.state ^ (this.state >>> 15), 1 | this.state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }

  // Random int between min (inclusive) and max (inclusive)
  int(min: number, max: number): number {
    return Math.floor(this.next() * (max - min + 1)) + min;
  }

  // Pick random element from array
  pick<T>(arr: T[]): T {
    if (arr.length === 0) return undefined as unknown as T;
    return arr[Math.floor(this.next() * arr.length)];
  }

  // Shuffle array in place
  shuffle<T>(arr: T[]): T[] {
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(this.next() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    return arr;
  }
}

// Global RNG instance - reseed per run
let rng = new SeededRandom(Date.now());

export function setGlobalSeed(seed: number): void {
  rng = new SeededRandom(seed);
}

export function getRng(): SeededRandom {
  return rng;
}
